import React, { Component } from 'react';
import {
    MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBCardBody, MDBIcon,
    MDBRow, MDBCol, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBDatePicker, MDBSelect
} from 'mdbreact';
import DataLayer from '../../Utilities/DataLayer';
import Formatter from '../../Utilities/Formatter';
import Colors from '../../Styles/Colors';

class DemonstratorCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flipped: false,
            extendedData: [],
            contactModalOpen: false,
            lastContactDate: this.props.lastContacted,
            latestContactDate: '',
            contactStatusSelection: [],
            contactedStateId: this.props.contactStatusId,
            lastContactedDisplay: this.props.hasContacted ? this.props.lastContacted : 'Not Contacted',
            lastContactedStateDisplay: this.props.contactStatus
        }
        this.handleFlipping = this.handleFlipping.bind(this);
        this.formatter = new Formatter();
        this.getButtons = this.getButtons.bind(this);
        this.getChannel = this.getChannel.bind(this);
        this.updateContacted = this.updateContacted.bind(this);
        this.updateContact = this.updateContact.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    handleSelectChange(selected) {
        this.setState({ contactedStateId: selected[0] })

    }

    async updateContact() {
        let selectedDate = ''
        if (this.state.latestContactDate == '') {
            selectedDate = new Date(this.state.lastContactDate);
        } else {
            selectedDate = new Date(this.state.latestContactDate);
        }
        let month = selectedDate.getMonth() + 1;
        selectedDate = selectedDate.getFullYear() + "/" + ((selectedDate.getMonth() + 1) < 10 ? "0" + (selectedDate.getMonth() + 1) : (selectedDate.getMonth() + 1)) + "/" + selectedDate.getDate()
        let postObj = {
            sfId: this.props.sfId,
            contactStateId: this.state.contactedStateId,
            contactDate: selectedDate
        };

        var dl = new DataLayer();
        let result = await dl.Post('/demonstrator/UpdateRecruitContactStatus', postObj);
        if (!result.errorOccurred) {
            let contactStatus = '';
            for (var i = 0; i < this.state.contactStatusSelection.length; i++) {
                if ((this.state.contactedStateId * 1) == (this.state.contactStatusSelection[i].value * 1)) {
                    contactStatus = this.state.contactStatusSelection[i].text;
                }
            }
            this.setState({
                contactModalOpen: false,
                lastContactedDisplay: selectedDate,
                lastContactDate: selectedDate,
                lastContactedStateDisplay: contactStatus
            })
            alert('Contact Details Updated Succesfully')
        } else {
            alert('An error ocurred updating contact details, Error: ' + result.errorMessage)
        }
    }

    async updateContacted() {
        var dl = new DataLayer();
        let result = await dl.Get('/demonstrator/getContactStatusList', 200);
        result.data.map((item) => {
            if ((this.state.contactedStateId * 1) == (item.value * 1)) {
                item.checked = true;
            }
        })
        this.setState({
            contactModalOpen: true,
            contactStatusSelection: result.data
            //contactStatusSelection: result.data
        })
    }

    async handleFlipping() {
        if (!this.state.flipped) {
            var dl = new DataLayer();
            await dl.Get('/common/getdemonstratorstats?demId=' + this.props.sfId + '&unitId=' + this.props.unitId, 200).then((response) => {
                var tttt = "";
                this.setState({
                    extendedData: response.data,
                    flipped: !this.state.flipped
                })

            })
        } else {
            this.setState({
                flipped: !this.state.flipped
            })
        }
    }

    addToWatch = (sfId, unitId) => {
        var dl = new DataLayer();
        dl.Get('/common/AddToWatchList?sfId=' + sfId + '&unitId=' + unitId, 200).then((response) => {
            alert('Added To Watch Successfully');
        })
    }

    getButtons(props) {
        if (props.userType == 'D') {
            return (
                <div className="flex-row text-center" >
                    <MDBBtn tag="a" color="cyan" floating onClick={this.handleFlipping}>
                        <MDBIcon icon="info" />
                    </MDBBtn>
                </div>
            )
        } else {
            return (
                <div className="flex-row text-center" >
                    <MDBBtn tag="a" color="purple" floating onClick={() => this.addToWatch(props.sfId, props.unitId)}>
                        <MDBIcon icon="glasses" />
                    </MDBBtn>
                    <MDBBtn tag="a" color="cyan" floating onClick={this.handleFlipping}>
                        <MDBIcon icon="info" />
                    </MDBBtn>
                </div>
            )
        }
    }

    getChannel(props) {
        if (props.recruitId > 0) {
            if (props.channel == 1) {
                return (
                    <span style={{ fontWeight: "bold" }}><MDBIcon far icon="check-circle" className="green-text" />&nbsp;Mobi Recruit</span>
                )
            }
            if (props.channel == 2) {
                return (
                    <span style={{ fontWeight: "bold" }}><MDBIcon icon="globe" className="green-text" />&nbsp;Online Recruit</span>
                )
            }
            if (props.channel == 3) {
                return (
                    <span style={{ fontWeight: "bold" }}><MDBIcon fas icon="link" className="green-text" />&nbsp;E-Recruit</span>
                    
                )
            }
        } else {
            return (
                <div></div>
            )
        }
    }

    render() {
        let telNo = "tel:" + this.props.telephoneCell;
        return (
            <div>
                {!this.state.flipped ? (
                    <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                        {/*<MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}><MDBIcon icon="users" />&nbsp;{dem.unitName.toUpperCase()}</MDBCardTitle>*/}
                        <MDBRow>
                            <MDBCol sm="12">
                                <MDBCardTitle style={{ fontSize: "16px" }}>&nbsp;<MDBIcon icon="user" />&nbsp;&nbsp;{this.props.demName}</MDBCardTitle>
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol sm="12">
                                {this.props.statusCode == "R" ? <span style={{ fontWeight: "bold" }}><MDBIcon far icon="file-alt" className="red-text" />&nbsp;Application Pending</span> : this.props.endWeekId > 0 ? <span style={{ fontWeight: "bold" }}><MDBIcon far icon="times-circle" className="red-text" />&nbsp;Discontinued</span> : <span style={{ fontWeight: "bold" }}><MDBIcon far icon="check-circle" className="green-text" />&nbsp;Active</span>}
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol sm="12">
                                {/*{this.props.recruitId > 0 ? this.props.channel == 1 ? <span style={{ fontWeight: "bold" }}><MDBIcon far icon="check-circle" className="green-text" />&nbsp;Mobi Recruit</span> : <span style={{ fontWeight: "bold" }}><MDBIcon icon="globe" className="green-text" />&nbsp;Online Recruit</span> : <div></div>}*/}
                                {this.getChannel(this.props)}
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol sm="12">
                                {this.props.cancelled ? <span style={{ fontWeight: "bold" }}><MDBIcon icon="user-times" className="red-text" />&nbsp;Application Cancelled</span> : <div></div>}
                            </MDBCol>

                        </MDBRow>
                        <MDBRow>
                            <MDBCol sm="12">
                                <span style={{ fontWeight: "bold" }}>Journey Type: {this.props.journeyType}</span>
                            </MDBCol>
                        </MDBRow>
                        {this.props.statusCode == "R" ? <div></div> : this.props.opt == "1" || this.props.statusCode1 == "D" ? <div>
                            <hr />

                            <MDBRow>
                                <MDBCol sm="12">
                                    Last Contacted: {this.state.lastContactedDisplay}
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol sm="12">
                                    Contact Status: {this.state.lastContactedStateDisplay}
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol sm="12">
                                    <MDBBtn rounded color="pink" size="sm" onClick={this.updateContacted}><MDBIcon icon="arrow-up" />&nbsp;Update</MDBBtn><br />
                                </MDBCol>
                            </MDBRow></div> : <div>
                            <hr />

                            <MDBRow>
                                <MDBCol sm="12">
                                    Last Contacted: {this.state.lastContactedDisplay}
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol sm="12">
                                    Contact Status: {this.state.lastContactedStateDisplay}
                                </MDBCol>
                            </MDBRow>
                        </div>}


                        <hr />
                        <MDBCardText>
                            <MDBIcon icon="phone" />&nbsp;<a href={telNo}>{this.props.telephoneCell}</a><br />
                            <MDBIcon far icon="id-card" />&nbsp;{this.props.sfCurrentCode}<br />
                            <MDBIcon far icon="play-circle" />&nbsp;{this.props.startWeekId}
                            <hr />
                            <MDBRow>
                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }} >
                                    <span style={{ fontSize: "14px" }}>Sales This Seg</span><br /> <strong>{this.formatter.formatCurrency(this.props.sales)}</strong>
                                </MDBCol>
                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                    <span style={{ fontSize: "14px" }}>Sales Prev Seg</span><br /> <strong>{this.formatter.formatCurrency(this.props.prevSegSales)}</strong>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardText>
                        <hr />
                        {this.getButtons(this.props)}
                    </MDBCard>
                ) : (
                    <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                        <MDBCardTitle style={{ fontSize: "16px" }}>&nbsp;<MDBIcon icon="user" />&nbsp;&nbsp;{this.props.demName}</MDBCardTitle>
                        <hr />
                        <MDBCardText>
                            <MDBRow>
                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }} >
                                    <span style={{ fontSize: "14px" }}>Sales This Seg</span><br /> <strong>{this.formatter.formatCurrency(this.state.extendedData.length > 0 ? this.state.extendedData[0].sales : 0)}</strong>
                                </MDBCol>
                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                    <span style={{ fontSize: "14px" }}>Total Sales</span><br /> <strong>{this.formatter.formatCurrency(this.state.extendedData.length > 0 ? this.state.extendedData[0].totalSales : 0)}</strong>
                                </MDBCol>
                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                    <span style={{ fontSize: "14px" }}>Recruits This Seg</span><br /> <strong>{this.state.extendedData.length > 0 ? this.state.extendedData[0].recruits : 0}</strong>
                                </MDBCol>
                                <MDBCol xl="6" lg="6" md="6" sm="12" className="mb-r" style={{ textAlign: "center" }}>
                                    <span style={{ fontSize: "14px" }}>Total Recruits</span><br /> <strong>{this.state.extendedData.length > 0 ? this.state.extendedData[0].totalRecruits : 0}</strong>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardText>
                        <hr />
                        <div className="flex-row text-center" >
                            <MDBBtn tag="a" color="grey" floating onClick={this.handleFlipping}>
                                <MDBIcon icon="undo-alt" />
                            </MDBBtn>
                        </div>
                    </MDBCard>
                )}

                <MDBModal isOpen={this.state.contactModalOpen} toggle={this.state.contactModalOpen} centered>
                    <MDBModalHeader><span style={{ color: "green" }}><MDBIcon far icon="edit" /></span>&nbsp;Update Contact</MDBModalHeader>
                    <MDBModalBody>
                        <MDBRow>

                            <MDBCol md="6">
                                <div class="block">

                                    <MDBDatePicker format="YYYY-MM-DD"
                                        invalidLabel=""
                                        invalidDateMessage="Please select a date"
                                        style={{ paddingTop: "15px" }}
                                        emptyLabel=""
                                        value={this.state.lastContactDate} label="Last Contacted"
                                        id="lastContacted" getValue={(e) => this.setState({ latestContactDate: e })} />

                                </div>

                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md="6">
                                <MDBSelect label="Select Contact Option"
                                    options={this.state.contactStatusSelection}
                                    selected="Status"
                                    getValue={this.handleSelectChange}
                                    required
                                />
                            </MDBCol>
                        </MDBRow>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={() => { this.setState({ contactModalOpen: false }) }}>Cancel</MDBBtn>
                        <MDBBtn rounded color="secondary" onClick={this.updateContact}>Update</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>
            </div>
        )
    }
}

export default DemonstratorCard;